import { type Item } from '../ProductList/models'
import { type ProductVariantTypes } from '../ConfigureAndBuy/types'

export const getIntensityGauge = (
  variant: Partial<Item | ProductVariantTypes>,
  intensityLabel?: string
) => [
  {
    ...(variant?.intensityMeter && {
      value: parseInt(variant?.intensityMeter, 10)
    }),
    scale: 10,
    ...(intensityLabel && { label: intensityLabel })
  }
]
